module.exports = __webpack_public_path__ + "static/media/kw.779ac6be.svg";